import AccountRoutes from './../../pages/Account/routes'
import AgencyBrandingRoutes from './../../pages/AgencyBranding/routes'
import AdminEOPolicyPageRoutes from './../../pages/AdminEOPolicyPage/routes'
import AdminReferralsPageRoutes from './../../pages/AdminReferrals/routes'
import AdminReportPageRoutes from './../../pages/AdminReports/routes'
import AdminRoyalRingsPageRoutes from './../../pages/AdminRoyalRingsPage/routes'
import AgentLedgerPageRoutes from './../../pages/AgentLedgers/routes'
import AgentContractingPageRoutes from './../../pages/AgentContractingPage/routes'
import CreateUserRoutes from './../../pages/CreateUser/routes'
import CRMRoutes from './../../pages/CRM/routes'
import WebSocketTestRoutes from './../../pages/Diagnostics/WebSocketTest/routes'
import EliteAgencyTeamPageRoutes from './../../pages/EliteAgencyTeams/routes'
import EnrollmentLinkCreatorRoutes from './../../pages/EnrollmentLinkCreator/routes'
import EventsRoutes from './../../pages/Calendar/routes'
import FirstSaleTrackerRoutes from './../../pages/FirstSaleTracker/routes'
import HomeRoutes from './../../pages/HomePage/routes'
import MilestonesPageRoutes from './../../pages/MilestonesPage/routes'
import PrivacyPolicyPageRoutes from './../../pages/PrivacyPolicyPage/routes'
import ProductAvailabilityRoutes from './../../pages/ProductAvailability/routes'
import PromotionCodesPageRoutes from './../../pages/PromotionCodesPage/routes'
import RaceToTheRingPageRoutes from './../../pages/RaceToTheRingPage/routes'
import RecruitingMeetingRoutes from './../../pages/RecruitingMeeting/routes'
import ReferralProgramPageRoutes from './../../pages/ReferralProgramPage/routes'
import ReportRoutes from './../../pages/Reports/routes'
import ResourceLibraryRoutes from './../../pages/ResourceLibrary/routes'
import SalesTrackerPageRoutes from './../../pages/SubmitSales/routes'
import SupportPageRoutes from './../../pages/Support/routes'
import CarrierPrioritiesRoutes from './../../pages/CarrierPriorities/routes'
import TrainingQuizesRoutes from './../../pages/TrainingQuizesPage/routes'
import UserManualsPageRoutes from './../../pages/UserManuals/routes'
import TechManualsPageRoutes from './../../pages/TechManuals/routes'
import UniversityPageRoutes from './../../pages/University/routes'
import WebsiteBrandingRoutes from './../../pages/WebsiteBranding/routes'

class RouteRegistry {
  _routes = []

  get routes() {
    return this._routes || []
  }

  constructor(...routes) {
    this._routes = Array.isArray(routes) ? routes.flat() : []
  }
}

export default new RouteRegistry(
  AccountRoutes,
  AgencyBrandingRoutes,
  AdminEOPolicyPageRoutes,
  AdminReferralsPageRoutes,
  AdminReportPageRoutes,
  AdminRoyalRingsPageRoutes,
  AgentLedgerPageRoutes,
  AgentContractingPageRoutes,
  CreateUserRoutes,
  CRMRoutes,
  WebSocketTestRoutes,
  EliteAgencyTeamPageRoutes,
  EnrollmentLinkCreatorRoutes,
  EventsRoutes,
  FirstSaleTrackerRoutes,
  HomeRoutes,
  MilestonesPageRoutes,
  PrivacyPolicyPageRoutes,
  ProductAvailabilityRoutes,
  PromotionCodesPageRoutes,
  RaceToTheRingPageRoutes,
  RecruitingMeetingRoutes,
  ReferralProgramPageRoutes,
  ReportRoutes,
  ResourceLibraryRoutes,
  SalesTrackerPageRoutes,
  SupportPageRoutes,
  CarrierPrioritiesRoutes,
  TrainingQuizesRoutes,
  UserManualsPageRoutes,
  TechManualsPageRoutes,
  UniversityPageRoutes,
  WebsiteBrandingRoutes
)
